<template>
    <tbody>
        <tr v-if="sortByGroup(bid)">
            <td colspan="21" style="background-color: white; font-size: medium">
                <i class="fas fa-gavel"></i>
                Group: {{ bid.group.name }}
                (Max Wins: {{ bid.group.max_wins }})
            </td>
        </tr>
        <tr :class="rowClass + ' ' + isStriped + ' ' + { 'is-cancel' : isCancel } + isAdminClass">
            <td v-if="isAdmin && isUserSinglePage">
                <bid-type v-bind:bid="bid" @classChanged="rowClass = $event"></bid-type>
            </td>
            <td v-if="isUserSinglePage">
                <span v-if="isAdmin" class="link" @click="goToUserPage(bid.user.id)">{{ bid.user.name }}</span>
                <span v-if="!isAdmin" class="link">{{ bid.user.name }}</span>
            </td>
            <td>
                <span v-html="getBidLotDateTime()"></span>
            </td>
            <td>
                <div class="display-flex">
                    <figure class="image  is-32x32" @click="index = 0" style="float: left;">
                        <img :src="bid.pictures.split('#')[0] + '&w=320'">
                    </figure>
                    <figure class="image  is-32x32" @click="index = 2">
                        <img :src="bid.pictures.split('#')[1] + '&w=320'">
                    </figure>
                </div>
            </td>
            <td>
                <button @click="goToBidSinglePage(bid.lot_id)" class="button is-small">
                    <span class="icon is-small" style="margin-right: 5px;">
                        <i class="fas fa-search-plus"></i>
                    </span>
                    {{ bid.bid }}
                </button>
            </td>
            <td>
                <button class="button is-small is-outlined" :class="isTranslated(bid.lot)" @click="openTranslateModal(bid)">
                    T
                </button>
            </td>
            <td><b class="has-text-danger">{{ bid.amount_yen * 1000 | formatNumber }}</b>
                <!--<bid-nego-start-price v-if="isAdmin && ((bid.status == '5' && getCurrentBidModalStatus.bidId == undefined)|| (getCurrentBidModalStatus.bidId == bid.id && getCurrentBidModalStatus.status == '5'))"  v-bind:bid="bid"></bid-nego-start-price>-->
                <bid-nego-start-price v-if="isAdmin && currentStatus != undefined && currentStatus == '5'"  v-bind:bid="bid"></bid-nego-start-price>
                <p v-if="!isAdmin && currentStatus != undefined && currentStatus == '5'"> {{ bid.nego_start_price * 1000 | formatNumber  }}</p>
            </td>
            <td class="result">
                <bid-result v-if="isAdmin"  v-bind:bid="bid"></bid-result>
                <p v-if="!isAdmin"> {{ bid.result_price * 1000 | formatNumber  }}</p>
            </td>
            <td>
                {{ bid.auction_name }}
            </td>
            <td @click="goToBidSinglePage(bid.lot_id)" class="has-pointer">{{ bid.company }}</td>
            <td @click="goToBidSinglePage(bid.lot_id)" class="has-pointer">{{ bid.model_name }}</td>
            <td @click="goToBidSinglePage(bid.lot_id)" class="has-pointer">{{ bid.model_type_en }}</td>
            <td @click="goToBidSinglePage(bid.lot_id)" class="has-pointer">{{ bid.mileage * 1000 | formatNumber }}</td>
            <td @click="goToBidSinglePage(bid.lot_id)" class="has-pointer">{{ bid.model_year_en }}</td>
            <td @click="goToBidSinglePage(bid.lot_id)" class="has-pointer">{{ bid.displacement_num }}</td>
            <td @click="goToBidSinglePage(bid.lot_id)" class="has-pointer">{{ bid.transmission }}</td>
            <td @click="goToBidSinglePage(bid.lot_id)" class="has-pointer">{{ bid.scores }}</td>
            <td @click="goToBidSinglePage(bid.lot_id)" class="has-pointer">{{ bid.position }}</td>
            <td @click="goToBidSinglePage(bid.lot_id)" class="has-pointer">
                <span v-if="isWin(bid)" class="win"><i class="fas fa-trophy"></i></span>
                <span v-else="" class="lose"><i class="fas fa-times-circle"></i></span>
            </td>
            <td>
                <bid-status v-if="isAdmin" v-bind:bid="bid"  @classChanged="rowClass = $event" @statusChanged="currentStatus = $event"></bid-status>
                <span  v-if="!isAdmin" :class="statusLabels[bid.status].tagClass">{{ statusLabels[bid.status].label }}</span>
            </td>
            <td v-if="isAdmin ">
               <bid-group v-bind:bid="bid"></bid-group>
            </td>
            <vue-gallery-slideshow :images="images" :index="index" @close="index = null" :id="bid.lot_id"></vue-gallery-slideshow>
            <result-modal :bid="bid" v-if="isAdmin"></result-modal>
            <translate-modal v-if="isAdmin && bid.lot !== null" :bid="bid"></translate-modal>
        </tr>
    </tbody>
</template>

<script>
    import VueGallerySlideshow from 'vue-gallery-slideshow'
    import apiBids from './../../api/apiBids'
    import bidType from './BidType.vue'
    import bidStatus from './BidStatus.vue'
    import bidResult from './BidResult.vue'
    import bidGroup from './BidGrpoup.vue'
    import ResultModal from './ResultModal.vue'
    import TranslateModal from './TranslateModal.vue'
    import BidNegoStartPrice from "./BidNegoStartPrice";
    export default {
        props:['bid', 'i'],
        components: {
            BidNegoStartPrice,
            VueGallerySlideshow,
            bidType,
            bidStatus,
            bidResult,
            bidGroup,
            ResultModal,
            TranslateModal
        },
        data () {
            return {
                index: null,
                images: this.bid.pictures.split('#'),
                rowClass: '',
                currentStatus: '',
                isAdminClass: "",
                statusLabels: [
                    {
                        tagClass: 'tag is-danger-outlined',
                        label: 'Canceled'
                    },
                    {
                        tagClass: 'tag is-theme-primary',
                        label: 'Active'
                    },
                    {
                        tagClass: 'tag is-success',
                        label: 'Win'
                    },
                    {
                        tagClass: 'tag is-danger',
                        label: 'Lose'
                    },
                    {
                        tagClass: 'tag is-warning',
                        label: 'Lose to other'
                    },
                    {
                        tagClass: 'tag is-black-outlined',
                        label: 'Unsold'
                    },
                    {
                        tagClass: 'tag is-info-outlined',
                        label: 'Negotiations'
                    },
                ]
            }
        },
        methods: {
            getBidLotDateTime() {
              if (this.bid.lot !== null) {
                  return  this.bid.lot.lot_date.split(' ')[0] + '<br>' + this.bid.lot.lot_date.split(' ')[1]
              } else {
                  return  this.bid.lot_date.split(' ')[0] + '<br>' + this.bid.lot_date.split(' ')[1]
              }
            },
            sortByGroup(bid){
                if (this.$store.getters.getBidsOrderColumn === 'group_id'){
                    if (bid.group.id !== null) {
                        if (this.i === 0){
                            return true
                        }
                        return this.$store.getters.getBids[this.i - 1].group.id !== bid.group.id
                    }
                }
            },
            isTranslated(lot) {
                if (typeof lot !== 'undefined' && lot !== null) {
                    if (lot.translation !== null) {
                        return 'is-primary'
                    } else {
                        return 'is-danger'
                    }
                }else {
                    return 'is-danger'
                }
            },
            openTranslateModal(bid) {
                this.$store.dispatch('changeTranslateModalStatus', { status: true, bidId: bid.id })
            },
            isWin(bid) {
                return bid.status === this.$bidStatusWin
            },
            goToUserPage(id) {
                this.$router.push({ path: '/users/edit/' + id})
            },
            goToBidSinglePage(id) {
                window.open('/single/' + id)
            }
        },
        computed: {
            isActive: function () {
                return this.$store.getters.getResultModalStatus(this.bid.id)
            },
            getCurrentBidModalStatus: function () {
                var status = this.$store.getters.getCurrentBidModalStatus(this.bid.id)
                console.log(status);
                return status;
            },
            isAdmin() {
                if (this.$store.getters.getUserRole === 'Admin') {
                    this.isAdminClass = ' is-admin';
                    return true
                }
                this.isAdminClass = '';
            },
            isUserSinglePage(){
                return location.pathname.split('/')[1] !== 'users'
            },
            isStriped() {

                if (this.i % 2 === 0) {
                    return 'white'
                } else {
                    return 'gray'
                }

            },
            isCancel() {
                return this.bid.status === this.$bidStatusCancel
            }
        },
        mounted() {
            if (this.bid.type === this.$bidIsAutomatic){
                this.rowClass = 'is-automatic'
            }
            if (this.bid.type === this.$bidIsReal){
                this.rowClass = 'is-real'
            }
            if (this.bid.status === this.$bidStatusCancel){
                this.rowClass = 'is-cancel'
            }
            if (this.bid.status === this.$bidStatusUnsold){
                this.currentStatus = '5'
            }
        }
    }
</script>

<style scoped>
    .lose {
        color: red;
        font-size: 20px;
    }
    .win {
        color: #ffd700;
        font-size: 20px;
    }
    tr {
        font-size: 10px;
        font-weight: bold;
    }
    .image {
        max-height: 32px;
        height: 32px;
        padding-left: 2px;
    }
    .link{
        cursor: pointer;
        border-bottom-color: blue;
    }
    .is-automatic.is-admin {
        background-color: rgba(0, 255, 255, 0.25) !important;
    }
    .is-real.is-admin {
        background-color: rgba(255, 255, 0, 0.27) !important;
    }
    .white {
        background-color: white;
    }
    .gray {
        background-color: whitesmoke;
    }
    .is-cancel.is-admin {
        background-color: rgba(255, 0, 0, 0.38) !important;
    }
    .has-pointer {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/Bids/BidTableRow.vue